"use client";
import clsx from "clsx";

import { useTranslation } from "~/app/hooks/useTranslation";
const dialogImgTr = "/brand/legacy/googleMaps-dialog-tr.png";
const dialogImg = "/brand/legacy/googleMaps-dialog.png";
import heroContentImg1Tr from "~/assets/images/googleMaps/hero-content-img1-tr.png?url";
import heroContentImg1 from "~/assets/images/googleMaps/hero-content-img1.png?url";
import Breadcrumb from "~/common/components/Breadcrumb";
import Image from "~/common/components/CustomImage";
import { LEAD_CAPTURE_MODAL_VARIANTS, openLeadCaptureModal } from "~/common/lib/leadCaptureModal";

import styles from "./GoogleMapsSection1.module.scss";

const GoogleMapsSection1 = ({ locale }) => {
  const { t } = useTranslation();

  const triggerChatbot = () => {
    openLeadCaptureModal({
      variant: LEAD_CAPTURE_MODAL_VARIANTS.BOOK_DEMO,
      source: "google-maps-section-1",
    });
  };

  return (
    <div className={clsx(styles.chatbotSection1, "card")}>
      <div className={clsx(styles.breadcrumb, "card")}>
        <Breadcrumb segments={[t("googleMaps.breadcrumb.products"), t("googleMaps.breadcrumb.reviews")]} />
      </div>
      <div className={styles.chatbotSection1Content}>
        <div className={styles.chatbotSection1ContentLeft}>
          <h1 className={clsx("pal-section-title", styles.chatbotSection1Title)} title={t("googleMaps.section1.title")}>{t("googleMaps.section1.title")}</h1>
          <p className={clsx("pal-section-desc", styles.chatbotSection1Desc)}>{t("googleMaps.section1.description")}</p>
          <button onClick={triggerChatbot}>{t("googleMaps.section1.bookADemo")}</button>
        </div>
        <div className={styles.chatbotSection1ContentRight}>
          <Image
            src={locale === "tr" ? heroContentImg1Tr : heroContentImg1}
            alt={t("googleMaps.section1.heroImageAlt")}
            width={485}
            height={586}
          />
        </div>
      </div>
      <div className={styles.chatbotSection1Content2}>
        <h4 className={styles.chatbotSection1Content2Title}>{t("googleMaps.section1.content2.title")}</h4>
        <p className={styles.chatbotSection1Content2Desc}>{t("googleMaps.section1.content2.description")}</p>
        <div className={styles.chatbotSection1Content2Dialog}>
          <Image
            src={locale === "tr" ? dialogImgTr : dialogImg}
            alt={t("googleMaps.section1.dialogImageAlt")}
            width={1312}
            height={460}
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleMapsSection1;
